import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import './TrendingCategories.css';
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Navigation, Autoplay } from 'swiper/modules';
import CategoryImage1 from './img/women.png'
import CategoryImage2 from './img/men.png'
import CategoryImage3 from './img/footwear.png'
import CategoryImage4 from './img/accessory.png'
import CategoryImage5 from './img/perfume.png'
import { useAppLanguage } from '../../../Hooks/useAppLanguage';

function TrendingCategories({ navigate }) {
    const { t, selectedLanguage, langPath } = useAppLanguage();

    return (
        <main className="trending-categories-main" dir="ltr">
            <section className="trending-categories-section">
                <div className="trending-categories-container container grid">
                    <h2 className='trending-categories-title section-title'>
                        {t('home.trendingCategories')}
                    </h2>

                    <Swiper
                        spaceBetween={30}
                        autoplay={{ delay: 10000, disableOnInteraction: false }}
                        loop={true}
                        navigation={{
                            nextEl: '.trending-categories-next-button',
                            prevEl: '.trending-categories-prev-button'
                        }}
                        modules={[Navigation, Autoplay]}
                        className="trending-categories-swiper"
                        breakpoints={{
                            300: { slidesPerView: 3, spaceBetween: 5 },
                            600: { slidesPerView: 4, spaceBetween: 30 },
                            768: { slidesPerView: 5, spaceBetween: 40 },
                            1024: { slidesPerView: 6, spaceBetween: 40 },
                        }}
                    >
                        {categories.map((item, index) => (
                            <SwiperSlide
                                key={index}
                                className="trending-categories-swiper-slide"
                                onClick={() => navigate(langPath(item.link))}
                            >
                                <div className='trending-categories-image-container'>
                                    <img
                                        className='trending-categories-img'
                                        src={item.image}
                                        alt={item.category[selectedLanguage]}
                                    />
                                </div>
                                <h3 className="trending-category-title">{item.category[selectedLanguage]}</h3>
                            </SwiperSlide>
                        ))}

                        <div>
                            <button className="trending-categories-prev-button">
                                <FaChevronLeft className="trending-categories-button-icon" />
                            </button>
                            <button className="trending-categories-next-button">
                                <FaChevronRight className="trending-categories-button-icon" />
                            </button>
                        </div>
                    </Swiper>
                </div>
            </section>
        </main>
    );
}

export default TrendingCategories;

const categories = [
    { category: { en: "Women", tr: "Kadın ", fa: "زن" }, link: "/products?category=women", image: CategoryImage1 },
    { category: { en: "Men", tr: "erkek", fa: "مرد" }, link: "/products?category=men", image: CategoryImage2 },
    { category: { en: "Footwear", tr: "ayakkabı ", fa: "کفش" }, link: "/products?category=footwear", image: CategoryImage3 },
    { category: { en: "Accessory ", tr: "Aksesuar", fa: "لوازم جانبی" }, link: "/products?category=accessory", image: CategoryImage4 },
    { category: { en: "Perfume", tr: "parfüm", fa: "عطر" }, link: "/products?category=perfume", image: CategoryImage5 },
    { category: { en: "Women", tr: "Kadın ", fa: "زن" }, link: "/products?category=women", image: CategoryImage1 },
    { category: { en: "Men", tr: "erkek", fa: "مرد" }, link: "/products?category=men", image: CategoryImage2 },
    { category: { en: "Footwear", tr: "ayakkabı ", fa: "کفش" }, link: "/products?category=footwear", image: CategoryImage3 },
    { category: { en: "Accessory ", tr: "Aksesuar", fa: "لوازم جانبی" }, link: "/products?category=accessory", image: CategoryImage4 },
    { category: { en: "Perfume", tr: "parfüm", fa: "عطر" }, link: "/products?category=perfume", image: CategoryImage5 },
];
